import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const Authmiddleware = ({ children }) => {
  const location = useLocation();

  // Check for both token types since the system seems to use both
  const isAuthenticated = localStorage.getItem("token") || localStorage.getItem("authUser");

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default Authmiddleware;
